import React, { createContext, useContext, useCallback, useState, useMemo } from "react";
import ErrorToast from "../Notification/ErrorToast";
import PropTypes from 'prop-types';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const addToast = useCallback((newMsg, success = false) => {
    const id = Date.now().toString();
    setMessages((prev) => [...prev, { id, newMsg, success }]);
  }, []);

  const removeToast = useCallback((id) => {
    setMessages((prev) => prev.filter((msg) => msg.id !== id));
  }, []);

  // ✅ Memoize the value object to fix SonarQube issue
  const contextValue = useMemo(() => ({ addToast }), [addToast]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <ErrorToast message={messages} onClose={removeToast} />
    </ToastContext.Provider>
  );
};
ToastProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };
export const useToast = () => useContext(ToastContext);
export const ToastContextConsumer = ToastContext.Consumer;
